import {
  TASK_AND_SHIFT_DATA_SUCCESS,
  TASK_ADDED_SUCCESS,
  SET_COMMENT_INDICATOR,
  TASK_DELETED_SUCCESS,
  GSRT_UPDATE_COMPLETE,
  GSRT_UPDATE_START,
  GSRT_UPDATE_ACK,
  LAV_FORCE_START_SUCCESS,
  LAV_FORCE_START_ERROR,
  COMPLETE_TASK_SUCCESS,
  COMPLETE_TASK_SUCCESS2,
  LAV_FORCE_START_ERROR_REMOVE,
  FETCH_TASK_TIMELINE_SUCCESS,
  TASK_AND_SHIFT_DATA_ERROR,
  POST_TASK_ACT_DATA_ERROR,
  COMPLETE_TASK_DATA_ERROR,
  DELETE_TASK_ACK_DATA_ERROR,
  BROADCAST_ACK,
  BROADCAST_ACK_SUCCESS,
  MYTIME_ACK_SUCCESS,
  OCCURENCE_ACK_SUCCESS,
  CLEAR_ACTIVE_ALERTS,
  ADD_SPINNER,
  REMOVE_SPINNER,
  EMPTY_TASK_AND_SHIFT_DATA,
  CHANGE_TASK_BAR_TO_HOME,
  CHANGE_TASK_BAR_TO_PROFILE,
  ADHOC_TASK_CREATE_SUCCESS,
  ADHOC_TASK_CREATE_ERROR,
  OPEN_TOUR_ON_LOGIN,
  CLOSE_TOUR_POPUP,
  
} from "./taskAndShiftConstant";
import {REHYDRATE} from 'redux-persist/lib/constants';

const initialState = {
  shiftandtaskData: {},
  ackReceipt: {},
  forceStartLav: {},
  forceStartLavError: false,
  timelineData: {},
  taskAndShiftDataError : false,
  apiError:{},
  showSpinner: false,
  selectedTaskBar: {
    value: "home",
    initial: true
  },
  displayRovrTour: null,
  complete: {},
  adhocTaskCreateSuccess: 0,
  openTour: null,
}; 

// --- Extracted helpers (ENG-3.1: reduce cognitive complexity) ---

const cloneShiftData = (state) =>
  JSON.parse(JSON.stringify(state.shiftandtaskData));

const findTask = (taskList, key, value) =>
  taskList.filter(task => task[key] === value);

const setGsrtPending = (state, taskId, field, value) => {
  const cloned = cloneShiftData(state);
  const matches = findTask(cloned.taskList, 'taskInstanceId', taskId);
  if (matches.length > 0) {
    matches[0][field] = value;
  }
  return { ...state, shiftandtaskData: { ...cloned } };
};

const handleTaskDataSuccess = (state, payload) => {
  if (payload.statusCode === 0 && payload.taskList !== null) {
    payload.taskList.forEach((task) => task['taskCommentInd'] = task.commentInd);
    return { ...state, shiftandtaskData: payload };
  }
  return { ...state, shiftandtaskData: payload };
};

const handleTaskAck = (state, action, listKey) => {
  if (action.payload.statusCode !== 0) {
    return { ...state, ackReceipt: action.payload };
  }
  const cloned = cloneShiftData(state);
  const matches = findTask(cloned[listKey], 'taskRID', action.taskRID);
  cloned.taskAlerts = cloned.taskAlerts.filter(
    task => task.taskInstanceId !== action.taskInstanceId
  );
  if (matches.length > 0) {
    matches[0].taskStatus = listKey === 'taskList' ? 'CONFIRMED' : matches[0].taskStatus;
    matches[0].ackRequired = false;
  }
  return { ...state, shiftandtaskData: { ...cloned }, ackReceipt: action.payload };
};

const handleLavForceStart = (state, action) => {
  if (action.payload.statusCode !== 0) {
    return { ...state, forceStartLav: action.payload };
  }
  const cloned = cloneShiftData(state);
  const matches = findTask(cloned.taskList, 'taskInstanceId', action.taskRID);
  if (matches.length > 0) {
    matches[0].taskStatus = 'STARTED';
  }
  return { ...state, shiftandtaskData: { ...cloned }, forceStartLav: action.payload };
};

// --- Reducer ---

const taskAndShiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case TASK_AND_SHIFT_DATA_SUCCESS:
      return handleTaskDataSuccess(state, action.payload);

    case REHYDRATE:
      return { ...state, persistedState: action.payload };

    case SET_COMMENT_INDICATOR: {
      const cloned = cloneShiftData(state);
      const matches = findTask(cloned.taskList, 'taskRID', action.payload.taskRID);
      matches[0].taskCommentInd = action.payload.status;
      return { ...state, shiftandtaskData: { ...cloned } };
    }

    case TASK_ADDED_SUCCESS:
      return handleTaskAck(state, action, 'taskList');

    case TASK_DELETED_SUCCESS:
      return handleTaskAck(state, action, 'deleteTaskList');

    case GSRT_UPDATE_COMPLETE:
      return setGsrtPending(state, action.taskId, 'gsrtUpdatePendingComplete', action.state);

    case GSRT_UPDATE_START:
      return setGsrtPending(state, action.taskId, 'gsrtUpdatePendingStart', action.state);

    case GSRT_UPDATE_ACK:
      return setGsrtPending(state, action.taskId, 'gsrtUpdatePendingAck', action.state);

    case LAV_FORCE_START_SUCCESS:
      return handleLavForceStart(state, action);
    case LAV_FORCE_START_ERROR:
      return { ...state, forceStartLavError: true };

    case LAV_FORCE_START_ERROR_REMOVE:
      return { ...state, forceStartLavError: false };

    case TASK_AND_SHIFT_DATA_ERROR:
      return { ...state, payload: action.error };

    case COMPLETE_TASK_SUCCESS2: {
      const completedTask = state.complete.taskCompleteProcessList[0];
      const taskList = completedTask.taskStatus === 0
        ? cloneShiftData(state).taskList.filter(t => t.taskInstanceId !== completedTask.smInstanceId)
        : [];
      return { ...state, shiftandtaskData: { ...state.shiftandtaskData, taskList } };
    }

    case COMPLETE_TASK_SUCCESS:
      return { ...state, complete: action.payload, showSpinner: false };

    case POST_TASK_ACT_DATA_ERROR:
    case COMPLETE_TASK_DATA_ERROR:
    case DELETE_TASK_ACK_DATA_ERROR:
      return { ...state, apiError: action.payload };

    case BROADCAST_ACK: {
      const cloned = cloneShiftData(state);
      if (action.messageType === 'myTimeAlert') {
        cloned.myTimeAlerts = cloned.myTimeAlerts.slice(1);
      } else if (action.messageType === 'occurenceAlert') {
        cloned.occurrenceAlerts = cloned.occurrenceAlerts.slice(1);
      } else {
        cloned.broadCastAlerts = cloned.broadCastAlerts.slice(1);
      }
      return { ...state, shiftandtaskData: { ...cloned } };
    }

    case BROADCAST_ACK_SUCCESS:
    case MYTIME_ACK_SUCCESS:
    case OCCURENCE_ACK_SUCCESS:
      return state;

    case FETCH_TASK_TIMELINE_SUCCESS:
      return { ...state, timelineData: action.payload };

    case CLEAR_ACTIVE_ALERTS: {
      const cloned = cloneShiftData(state);
      cloned.broadCastAlerts = [];
      cloned.taskAlerts = [];
      cloned.myTimeAlerts = [];
      cloned.occurrenceAlerts = [];
      return { ...state, shiftandtaskData: { ...cloned } };
    }

    case ADD_SPINNER:
      return { ...state, showSpinner: true };

    case REMOVE_SPINNER:
      return { ...state, showSpinner: false };

    case EMPTY_TASK_AND_SHIFT_DATA:
      return { ...state, shiftandtaskData: {} };

    case CHANGE_TASK_BAR_TO_HOME:
      return { ...state, selectedTaskBar: { value: "home", initial: false } };

    case CHANGE_TASK_BAR_TO_PROFILE:
      return { ...state, selectedTaskBar: { value: "profile", initial: false } };

    case OPEN_TOUR_ON_LOGIN:
      return {
        ...state,
        displayRovrTour: action.payload,
        ...(action.payload ? { openTour: action.payload } : {}),
      };

    case CLOSE_TOUR_POPUP:
      return { ...state, openTour: action.payload };

    case ADHOC_TASK_CREATE_SUCCESS:
      return { ...state, adhocTaskCreateSuccess: state.adhocTaskCreateSuccess + 1 };

    default:
      return state;
  }
};

export default taskAndShiftReducer;